import React from 'react';
import { connect } from 'react-redux'
import { Spin } from 'antd';
import {AdmsRepository} from '../../redux/AdmsActions';
import {subsetByLang} from '../../virtuoso/helper';
import ClampLines from 'react-clamp-lines';
import i18n from "i18next";


/** Компонента, отображающая описание элемента. Значение для предиката http://purl.org/dc/terms/description
 * 
 * В начале Description отображает загрузку, в этот момент запрашивается информация об описании , если 
 * значение найдено, то отображается найденноей значения, если нет, то отображается "" */
const Loading = () => <span><Spin size="small" /></span>
const Label = ({lang, description}) => {
    const subset = (description)?subsetByLang(description, lang, "description"): [];
    //console.log("Description.js const Label = ({lang, description})", subset);
    const label = (Array.isArray(subset)&&subset.length>0)?subset[0].description.value:"";
    return (
        <ClampLines text={label} id="default" lines={1} moreText={i18n.t('components.widgets.description_moreText')} 
            lessText={i18n.t('components.widgets.description_lessText')} innerElement="span" stopPropagation={true} />
    )
}
class Description extends React.Component {
    state = {
        loaded: false,
        IRI: null,
        value: undefined
    };

    componentDidMount() {
        this.loadDescription();
    }

    componentDidUpdate(prevProps, prevState) {
        this.loadDescription();
    }

    static getDerivedStateFromProps(props, state) {
        //console.log("Description.js static getDerivedStateFromProps(props, state)", props, state);
        if ((props.description==null) || (props.description==undefined) || (props.IRI!=state.IRI)) {
          return {
            loaded: false,
            IRI: props.IRI
          };
        } else {
            if ((props.IRI==state.IRI) && (props.description))
                return {
                    loaded: true,
                    IRI: props.IRI,
                    value: props.description
                };
        }
        return null; // Return null to indicate no change to state.
    }

    loadDescription () {
        //console.log("loadDescription ()", this);
        if (this.state.loaded) return;
        //return;
        const {IRI, graph} = this.props;
        this.props.dispatch(AdmsRepository.loadDescription(IRI, graph))
            .then ((response) =>{
                //console.log("Done!", response);
                this.setState({loaded: true});
            })
            .catch(e => { 
                console.error("Error!", e);
                this.setState({loaded: true});
            });
    }

    render(){
        //console.log(this);
        const Component = (this.state.loaded)? Label: Loading;
        return(
            <Component {...this.props} {...this.state} />
        )
    }
}

function mapStateToProps(state, props) {
    //Значения в store redux
    const {vadms, vset} = state;
    //Параметры, которые могут прийти из настроек
    const {graph, IRI, lang, description} = props;
    return {
        graph: (graph)? graph: vset.graph,
        lang: (lang)?lang: vset.lang,
        IRI,
        vset,
        description,
    };
}

export default connect(mapStateToProps)(Description);